
/* injects from baggage-loader */

'use strict';

import config from './index.config';
import run from './index.run';

import uiRouter from '@uirouter/angularjs';

import coreModule from './core/core.module';
import indexComponents from './index.components';
import indexRoutes from './index.routes';

// Import ui bootstrap modules
import alert from 'ui-bootstrap4/src/alert';
import modal from 'ui-bootstrap4/src/modal';
import accordian from 'ui-bootstrap4/src/accordion';

// Import pages
import homeModule from './pages/home/home.module';
import loginModule from './pages/login/login.module';
import signupModule from './pages/signup/signup.module';
import recoverPassword from './pages/recoverPassword/recoverpassword.module';
import passwordReset from './pages/passwordReset/passwordreset.module';
import aboutModule from './pages/about/about.module';
import raiseFundsModule from './pages/raise-funds/raise-funds.module';
import projectsModule from './pages/projects/projects.module';
import projectModule from './pages/project/project.module';
import projectDonationWizardPageModule from './pages/project-donation-wizard/project-donation-wizard.module';
import accountModule from './pages/account/account.module';
import accountLogoutModule from './pages/account-logout/account-logout.module';
import manageProjectModule from './pages/manageProject/manageproject.module';
import donationConfirmationModule from './pages/donation-confirmation/donation-confirmation.module';
import raiseSubmittedConfirmationModule from './pages/raise-submitted-confirmation/raise-submitted-confirmation.module';
import PageNotFoundPageModule from './pages/page-not-found/page-not-found.module';
import ProjectEditorPageModule from './pages/project-editor/project-editor.module';

// Site Admin pages
import AdminPageModule from './pages/admin/admin.module';

// Terms and Policy pages
import cookiePolicyModule from './pages/legal/cookie-policy/cookie-policy.module';
import termsOfUseModule from './pages/legal/terms-of-use/terms-of-use.module';
import privacyPolicy from './pages/legal/privacy-policy/privacy-policy.module';

const App = angular.module("neighborFunds",
	[
		// plugins
		uiRouter,
		"ngAnimate",
		"ngCookies",
		"ngTouch",
		"ngSanitize",
		"ngMessages",
		"ngAria",
		"ngResource",
		"oc.lazyLoad",
		"ngSentry",
		
		"angular-loading-bar",
		"ngAvatar",
		"yaru22.angular-timeago",
		"angular-stripe",
		"angularPayments",
		"textAngular",
		"duScroll",
		"ngFileUpload",
		"dndLists",
		"angularConsent",

		// UI Bootstrap modules
		alert,
		modal,
		accordian,

		// core
		coreModule.name,

		// components
		indexComponents.name,

		// routes
		indexRoutes.name,

		// pages
		homeModule.name,
		loginModule.name,
		signupModule.name,
		recoverPassword.name,
		passwordReset.name,
		aboutModule.name,
		raiseFundsModule.name,
		projectsModule.name,
		projectModule.name,
		projectDonationWizardPageModule.name,
		manageProjectModule.name,
		donationConfirmationModule.name,
		raiseSubmittedConfirmationModule.name,
		PageNotFoundPageModule.name,
		ProjectEditorPageModule.name,

		// admin pages
		AdminPageModule.name,

		// pages: User account
		accountModule.name,
		accountLogoutModule.name,

		// pages: terms and policy
		cookiePolicyModule.name,
		termsOfUseModule.name,
		privacyPolicy.name

	]
);

App
	.config(config)
	.run(run);

export default App;


// WEBPACK FOOTER //
// ./src/app/index.module.js